module.exports = __webpack_public_path__ + "style/img/PD_icon_IoT 1.cd72fb60.png";